// Finans işlemlerinin panelde gösterimi için ortak yardımcılar.
// Hem liste satırı hem de detay paneli aynı normalizasyonu kullanır;
// ikisinde ayrı ayrı biçimlendirme yapılmasın.

export const formatIban = (value = '') => {
  const compact = String(value).replace(/\s+/g, '').toUpperCase();
  return compact.match(/.{1,4}/g)?.join(' ') || '';
};

// İşlem notu birden çok satır taşıyabilir. Çekimlerde ödeme hesabı bilgisi
// detay panelinde ayrı bir kartta gösterildiği için not metninden düşülür.
export const transactionNoteLines = (item) => {
  const lines = String(item?.note || '')
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);
  if (item?.type === 'withdraw') {
    return lines.filter((line) => !/^(IBAN|Cüzdan)\s*:/i.test(line));
  }
  return lines;
};

export const visibleTransactionNote = (item) => transactionNoteLines(item).join(' · ');

// Hareketi açan ya da sonuçlandıran yetkilinin adı. Denetim izi ayrı bir
// yetkiyle korunduğu için "bu bonusu kim verdi" sorusu finans listesinden de
// yanıtlanabilmelidir. Oyuncunun kendi talebi, sağlayıcı hareketi ve karara
// bağlanmamış kayıtlarda yetkili yoktur; boş döner.
export const transactionActor = (item) => String(item?.admin_username || '').trim();

// Çekim ödeme hesabını türünden bağımsız tek bir görünüm nesnesine indirger.
// Yatırımlarda ödeme hesabı yoktur; null döner.
export const payoutAccountView = (item) => {
  if (item?.type !== 'withdraw') return null;
  const account = item.payout_account || {};
  // Sağlayıcı cüzdanına çekim (Payurus/CepPay): hedef bir IBAN değil, cüzdan
  // numarasıdır ve hesap sahibinin adı sağlayıcıya birlikte gönderilir.
  if (account.type === 'wallet') {
    const walletId = account.wallet_id || '';
    return {
      kind: 'wallet',
      title: account.account_holder || 'Cüzdan sahibi belirtilmedi',
      subtitle: 'Sağlayıcı cüzdanı',
      codeLabel: 'Cüzdan numarası',
      code: walletId,
      codeText: walletId || 'Cüzdan numarası yok',
    };
  }
  if (account.type === 'crypto') {
    const address = account.wallet_address || '';
    return {
      kind: 'crypto',
      title: account.asset || 'Kripto',
      subtitle: account.network || 'Ağ belirtilmedi',
      codeLabel: 'Cüzdan adresi',
      code: address,
      codeText: address || 'Cüzdan adresi yok',
    };
  }
  const iban = account.iban || '';
  return {
    kind: 'iban',
    title: account.account_holder || 'Hesap sahibi belirtilmedi',
    subtitle: account.bank_name || 'Banka belirtilmedi',
    codeLabel: 'IBAN',
    code: iban,
    codeText: iban ? formatIban(iban) : 'IBAN yok',
  };
};

// Onay penceresinin açıklamasına eklenen tek satırlık ödeme hesabı özeti.
export const payoutDescription = (item) => {
  const view = payoutAccountView(item);
  if (!view) return '';
  return ` Ödeme hesabı: ${view.title} · ${view.subtitle} · ${view.code || 'bilgi yok'}.`;
};

// Panoya kopyalama; tarayıcı izin vermezse sessizce başarısız sayılır.
export const copyToClipboard = async (value) => {
  if (!value) return false;
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch (error) {
    return false;
  }
};
